import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { BsImage } from "react-icons/bs";
import * as yup from "yup";
import CategoryService from "../../services/category.service";
import useDialogState, { Loader } from "../../hook";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { notifyError, notifySuccess } from "../../hook/notification";

// Custom Dropdown component
const Dropdown = ({ options, onSelect, selectedValue, name }) => {
  const menuRef = useRef();
  const [toggleShow, setToggleShow] = useState(false);

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="flex flex-col gap-2 relative">
      <div onClick={userToggle} className="input cursor-pointer">
        {selectedValue === "" ? "Select" : selectedValue === true ? "Preview" : "Not Preview"}
      </div>
      <div
        className={`${toggleShow ? "block" : "hidden"
          } bg-gray-800 rounded-6 overflow-hidden absolute top-[40px] w-full z-70 min-h-10 max-h-52 h-auto overflow-y-auto`}
      >
        {options.map((option, index) => (
          <p
            key={index}
            name={name}
            onClick={() => {
              onSelect(option.value);
              setToggleShow(false);
            }}
            className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white"
          >
            {option.label}
          </p>
        ))}
      </div>
    </div>
  );
};


const AddCategory = () => {
  const location = useLocation()
  const menuRef = useRef();
  const navigate = useNavigate()
  const hiddenFileInput = useRef(null);
  const [showVal, setShowVal] = useState(true);
  const [fileName, setFileName] = useState("");

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const handleFile = (file) => {
    setFileName(file.name);
  };
  const handleSelect = (value) => {
    setShowVal(value);
    formik.setFieldValue("previewEnable", value)
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    formik.setFieldValue("CategoryPhoto", fileUploaded)
    handleFile(fileUploaded);
  };

  const PreviewOption = [
    { label: "Preview", value: true },
    { label: "Not Preview", value: false }
  ];

  const schema = yup.object().shape({
    // CategoryPhoto: yup.mixed().required("Please upload photo"),
    categoryName: yup.string().required("Please enter name"),
    previewEnable: yup.string().required("Please select preview"),
  });

  const initialValue = {
    CategoryPhoto: "",
    categoryName: "",
    previewEnable: true,
    id: "",
    position: 0
  };

  useEffect(() => {
    if (location.state !== null) {
      const data = location.state;
      formik.setFieldValue("CategoryPhoto", "");
      formik.setFieldValue("id", data.id);
      formik.setFieldValue("categoryName", data.categoryName);
      formik.setFieldValue("position", data.position + 1);
      formik.setFieldValue("previewEnable", data.previewEnable);
      setFileName(data.categoryBackgroundImage.split('/').pop().split('-').slice(1).join('-'))
      setShowVal(data.previewEnable);
    }
  }, [location]);

  const submit = async (values, action) => {
    const { categoryName, previewEnable, CategoryPhoto, id, position } = values;
    if (!values.id) {
      try {
        const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
        const fileData = new FormData();
        fileData.append("CategoryPhoto", CategoryPhoto || emptyFile);
        setLoader();
        await CategoryService.createCategory(categoryName, Boolean(previewEnable), fileData);
        notifySuccess("Category create successfully");
        setTimeout(() => {
          setFileName("");
          unSetLoader();
          navigate('/categories');
          action.resetForm();
        }, 1500);
      } catch (error) {
        notifyError("Something went wrong");
        setTimeout(() => {
          setFileName("");
          unSetLoader();
          navigate('/categories');
          action.resetForm();
        }, 1500);
        console.error("create error", error);
        unSetLoader();
      }
    } else {
      try {
        const newPosition = position === 1 ? 0 : position - 1;
        const fileData = new FormData();
        fileData.append("CategoryPhoto", CategoryPhoto);
        fileData.append("categoryId", id);
        fileData.append("categoryName", categoryName);
        fileData.append("position", newPosition);
        fileData.append("previewEnable", previewEnable);
        setLoader();
        await CategoryService.updateCategory(fileData);
        notifySuccess("Category update successfully");
        setTimeout(() => {
          setFileName("");
          unSetLoader();
          navigate('/categories')
          action.resetForm();
        }, 1500);
      } catch (error) {
        console.error("create error", error);
        notifyError("Something went wrong")
        unSetLoader();
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  return (
    <>
      <div
        className="max-w-[900px] min-w-[300px] w-auto px-5 pb-10"
        ref={menuRef}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="py-10">
            <h1 className="text-base font-semibold leading-7 text-white">
              Insert Category
            </h1>
            <p className="text-sm text-gray-500">
              Please Enter category Information
            </p>
          </div>
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Category Name</label>
            <input className="input" placeholder="category name" name="categoryName" value={formik.values.categoryName} onChange={formik.handleChange} type="text" />
            {formik.errors.categoryName && formik.touched.categoryName &&
              <div className="text-red text-sm">{formik.errors.categoryName}</div>
            }
          </div>
          {location.state !== null &&
            <div className="flex flex-col gap-2 mb-7">
              <label className="label">Position</label>
              <input className="input" placeholder="Enter position" name="position" value={formik.values.position} onChange={formik.handleChange} type="number" />
            </div>
          }

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Preview Enable</label>
            <Dropdown
              options={PreviewOption}
              onSelect={(value) => handleSelect(value)}
              selectedValue={showVal}
              name="previewEnable"
            />
            {formik.errors.previewEnable && formik.touched.previewEnable &&
              <div className="text-red text-sm">{formik.errors.previewEnable}</div>
            }
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Preview Image</label>
            <div className="flex items-center gap-5">
              <input type="image" accept="image/*" id="upload" hidden />
              <label
                onClick={handleClick}
                className="border border-white rounded-6 flex items-center justify-center flex-col gap-5 p-4 cursor-pointer w-full lg:p-10 text-center"
              >
                <BsImage className="text-gray-600 text-5xl" />
                <span className="text-white text-sm  ">
                  {fileName === "" ? (
                    <>
                      <span className="text-center">
                        <strong>Upload a file {" "}</strong>
                        or drag and drop <br />
                        PNG, JPG, GIF
                      </span>
                    </>
                  ) : (
                    fileName
                  )}
                </span>
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleChange}
                ref={hiddenFileInput}
                className="hidden"
                name="CategoryPhoto"
              />
            </div>
            {formik.errors.CategoryPhoto && formik.touched.CategoryPhoto &&
              <div className="text-red text-sm mb-4">{formik.errors.CategoryPhoto}</div>
            }
          </div>
          <div className="flex justify-end gap-4 items-center">
            <button type="button" onClick={() => navigate(-1)} className="btn cancel">Cancel</button>

            <button type="submit" className="btn save">{loader ? <Loader /> : "Save"}</button>
            <ToastContainer autoClose={1500} />
          </div>
        </form>
      </div>
    </>
  );
};

export default AddCategory;
